import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getMachines({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_MACHINES_REQUEST')

        return axios
            .get(`/machines/machines${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_MACHINES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MACHINES_FAILURE')
                handleApiError(error, 'Pobranie maszyn nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCalculationMachines({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_MACHINES_REQUEST')

        return axios
            .get(`/calculations/calculations/machines${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_MACHINES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MACHINES_FAILURE')
                handleApiError(error, 'Pobranie maszyn nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachine(context, id) {
        return axios
            .get(`/machines/machines/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o maszynie nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachinePrintTypes() {
        return axios
            .get('/machines/machines/dicts/machine-print-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rodzajów druku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachineSheetFormats() {
        return axios
            .get('/machines/machines/dicts/machine-sheet-formats')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie formatów arkuszy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMachinePlateTypes() {
        return axios
            .get('/machines/machines/dicts/machine-plate-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rodzajów płyt nie powiodło się.')
            })
    },
    getMachineDurGroups() {
        return axios
            .get('/machines/machines/dicts/machine-dur-groups')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie grup DUR nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createMachine({ commit }, payload) {
        return axios
            .post('/machines/machines', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Maszyna została dodana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie maszyny nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateMachine({ commit }, payload) {
        return axios
            .put(`/machines/machines/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Maszyna została zedytowana.'
                }, { root: true })

                commit('UPDATE_MACHINE', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja maszyny nie powiodła się.')

                return Promise.reject(error)
            })
    },
    updateMachineProcessCost({ commit }, payload) {
        return axios
            .put(`/machines/machines/machine-process-costs/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Koszt został zaktualizowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja maszyny nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setMachinesFilters({ commit }, filters) {
        commit('SET_MACHINES_FILTERS', filters)
    },
    clearMachinesFilters({ commit }) {
        commit('CLEAR_MACHINES_FILTERS')
    }
}